
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { filterModel } from 'src/Models/WirelessModel';

@Injectable({
  providedIn: 'root'
})
export class WirelessService {
  AppUrl: string = "";
  filterModel = new filterModel();

  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.AppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  getMatrix(TokenKey: string, StateID: string, UserID: any, ColumnIndex: any, OrderBy: any, WhereCondition: any, productId: number): Observable<any> {
    this.setAPIUrl();
    this.filterModel.stateID = StateID;
    this.filterModel.userID = UserID;
    this.filterModel.columnIndex = ColumnIndex;
    this.filterModel.orderBy = OrderBy;
    this.filterModel.whereCondition = WhereCondition;
    this.filterModel.productId = productId;

    let URL = this.AppUrl + 'api/Matrix/GetMatrix';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(URL, this.filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getState(TokenKey: string, userId: number, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/Matrix/GetState/' + userId + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetfundRefrence(TokenKey: string, StateID: string, AssementCatId: any, LoginUser: any, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/Matrix/GetfundRefrence/' + StateID + '/' + AssementCatId + '/' + LoginUser + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUpdatesFilterByPage(TokenKey: string, PageNumber: string, PageSize: string, WhereCondition: string, OrderBy: string, keywordFilter: string, productId: number, isActionRequired: boolean, systemUserCondition: string): Observable<any> {
    this.setAPIUrl();
    this.filterModel.pageNumber = PageNumber;
    this.filterModel.pageSize = PageSize;
    this.filterModel.whereCondition = WhereCondition;
    this.filterModel.orderBy = OrderBy;
    this.filterModel.keywordFilter = keywordFilter;
    this.filterModel.productId = productId;
    this.filterModel.isActionRequired = isActionRequired;
    this.filterModel.systemUserCondition = systemUserCondition;

    let fullAPIPath = this.AppUrl + 'api/Updates/GetUpdatesFilterByPage';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, this.filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  deleteupdates(TokenKey: string, updateId: number): Observable<any[]> {
    let data = '/' + updateId;
    let fullAPIPath = this.AppUrl + 'api/Updates/DeleteUpdate' + data;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  activeinactiveupdates(TokenKey: string, updateId: string, isactive: string): Observable<any[]> {
    let data = '/' + updateId;
    let fullAPIPath = this.AppUrl + 'api/Updates/ActiveInActiveUpdate' + data + '/' + isactive;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetMatrixFundbyStateId(TokenKey: string, StateId: string, productId: number): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetMatrixFundByStateId/' + StateId + "/" + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getFundFields(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    let data = 'api/Updates/GetFundFieldAll';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getUpdateCategory(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    let data = 'api/Updates/GetUpdateCategoryGetAll';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  addupdateupdates(user, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/Updates/AddUpdateUpdates', user, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getupdatesfindByID(TokenKey: string, UpdateId: number): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetUpdatesFindByID/' + UpdateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(fullAPIPath, httpOptions).pipe(catchError(this.handleError));
  }

  getupdatesfindByUserID(TokenKey: string, parameter): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetUpdatesFindByUserID';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, parameter, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getupdatesfindByUserIDByCount(TokenKey: string, parameter): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetUpdatesFindByUserIDByCount';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, parameter, httpOptions)
      .pipe(catchError(this.handleError));
  }

  addNotification(updates, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/Updates/AddNotification', updates, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetClientCompany(TokenKey: string, productId: any, whereCondition: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + 'api/Updates/GetClientCompany/' + productId + '/' + whereCondition, httpOptions)
      .pipe(catchError(this.handleError));
  }

  getIPCSupdatesfindByUserID(TokenKey: string, parameter): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetIPCSUpdatesFindByUserID';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, parameter, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AddIIPCSNotification(updates, TokenKey: string): Observable<any> {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(this.AppUrl + 'api/Updates/AddIPCSNotification', updates, httpOptions)
      .pipe(catchError(this.handleError));
  }

  ActiveinactiveIPCSupdates(TokenKey: string, updateId: string, isactive: string): Observable<any[]> {
    let data = '/' + updateId;
    let fullAPIPath = this.AppUrl + 'api/Updates/ActiveInActiveIPCSUpdate' + data + '/' + isactive;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetIPCSupdatesfindByUserIDByCount(TokenKey: string, parameter): Observable<any> {
    this.setAPIUrl();
    let fullAPIPath = this.AppUrl + 'api/Updates/GetIPCSUpdatesFindByUserIDByCount';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(fullAPIPath, parameter, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetMatrixFindByStateID(TokenKey: string, UserID: string, StateId: any, ProductId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/MatrixFundDetails/GetMatrixFindByStateID/' + UserID + '/' + StateId + '/' + ProductId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetMatrixFundState(TokenKey: any, userId: number, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/MatrixFundDetails/GetMatrixFundFindByStateID/' + userId + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetMatrixStatesByUserID(TokenKey: any, UserID: any, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/IPRUpdates/GetMatrixStatesByUserID/' + UserID + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  RemoveMatrixFavoriteByUserID(TokenKey: any, UserID: any, productId: number, DeSelectedFavoriteId: any): Observable<any> {
    this.setAPIUrl();
    let data = 'api/IPRUpdates/RemoveMatrixFavoriteByUserID/' + UserID + '/' + productId + '/' + DeSelectedFavoriteId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  SaveUserPrefrences(TokenKey: string, ListofID: any, UserID: any, productId: number): Observable<any> {
    this.setAPIUrl();
    let data = 'api/Matrix/SaveUserPrefrences/' + ListofID + '/' + UserID + '/' + productId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return observableThrowError(error.status)
  }
}
